import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import AppForAppPage from '@/pages/App/types/AppForAppPage';
import { scheduleBuildPath } from '@/utils/monolithApiRouteService';
import { queryClient } from '@/utils/query';

type UpdateScheduledBuildProps = {
  app: AppForAppPage;
};

const useUpdateScheduledBuild = ({ app }: UpdateScheduledBuildProps) => {
  return useMonolithApiMutation(
    scheduleBuildPath(app.slug, {
      params: {
        build_trigger_token: app.buildTriggerToken,
      },
    }),
    'post',
    {
      onSuccess: () => {
        queryClient.refetchQueries({ queryKey: ['scheduledBuilds', app.slug] });
      },
    },
  );
};

export default useUpdateScheduledBuild;
